/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-use-before-define */
/* eslint-disable no-useless-concat */
import React, { useState, useEffect, useRef } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
// import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import '../App.css';
import { DataGrid, GridLogicOperator, gridClasses, GridToolbarContainer, GridToolbarExport, GridToolbarFilterButton, GridToolbarColumnsButton, GridToolbarDensitySelector, GridToolbarQuickFilter } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import { Paper, Button } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';
// import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { makeStyles } from '@mui/styles';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Select, { components } from 'react-select';
import { useStateContext } from '../contexts/ContextProvider';
import Sidebar from '../components/Sidebar';
import { Navbar } from '../components';
import { variables } from '../components/Variables';
import SLAGraph from './SLAGraph';
import LoadingOverlay from '../components/LoadingOverlay';
import DateRangePicker from '../contexts/CustomDatePicker';
import CustomDataGrid from '../contexts/CustomDataGrid';

const columns = [
  { field: 'Reference', headerName: 'Reference', width: 300, headerAlign: 'left', align: 'left' },
  { field: 'TrackingNumber', headerName: 'TrackingNumber', width: 400, headerAlign: 'left', align: 'left', valueFormatter: ({ value }) => `${(value)?.toString()}` + '\t', renderCell: (params) => (<div style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}><div>{params.value}</div></div>) },
  { field: 'TrackingDeliveredOn', headerName: 'TrackingDeliveredOn', width: 300, headerAlign: 'left', align: 'left' },
  { field: 'ReceivedDate', headerName: 'ReceivedDate', width: 250, headerAlign: 'left', align: 'left' },
  { field: 'AgeSince', headerName: 'AgeSince', width: 250, headerAlign: 'left', align: 'left' },
];
const columns2 = [
  { field: 'RMA', headerName: 'RMA', width: 200, headerAlign: 'left', align: 'left' },
  { field: 'TrackingNumber', headerName: 'TrackingNumber', width: 300, headerAlign: 'left', align: 'left', valueFormatter: ({ value }) => `${(value)?.toString()}` + '\t', renderCell: (params) => (<div style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}><div>{params.value}</div></div>) },
  { field: 'SKU', headerName: 'SKU', width: 150, headerAlign: 'left', align: 'left' },
  // { field: 'Qty', headerName: 'Qty', width: 150, headerAlign: 'left', align: 'left' },
  { field: 'Notes', headerName: 'Notes', renderCell: (params) => (<div style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}><div>{params.value}</div></div>), width: 750, headerAlign: 'left', align: 'left' },
];
const useStyles = makeStyles({
  columnsButton: {
    scale: 1.25,
    padding: '8px', // customize the padding to adjust the size
  },
});
function CustomToolbar() {
  const classes = useStyles();
  return (
    <div className="container-fluid">
      <div className="row" id="table_feature">
        <GridToolbarContainer>
          <div className="col-xs-8 col-sm-6 col-md-4 col-lg-2">
            <GridToolbarColumnsButton className={classes.columnsButton} />
          </div>
          <div className="col-xs-8 col-sm-6 col-md-4 col-lg-2">
            <GridToolbarDensitySelector className={classes.columnsButton} />
          </div>
          <div className="col-xs-8 col-sm-6 col-md-4 col-lg-2">
            <GridToolbarFilterButton className={classes.columnsButton} />
          </div>
          <div className="col-xs-8 col-sm-6 col-md-4 col-lg-2">
            <GridToolbarExport
              printOptions={{ disableToolbarButton: true }}
              csvOptions={{
                fileName: 'Returns SLA',
              }}
              className={classes.columnsButton}
            />
          </div>
          <div id="quick_search">
            <GridToolbarQuickFilter />
          </div>
        </GridToolbarContainer>
      </div>
    </div>
  );
}

const ODD_OPACITY = 0.2;

const StripedDataGrid = styled(DataGrid)(({ theme }) => ({
  [`& .${gridClasses.row}.even`]: {
    backgroundColor: theme.palette.grey[200],
    '&:hover, &.Mui-hovered': {
      backgroundColor: alpha(theme.palette.primary.main, ODD_OPACITY),
      '@media (hover: none)': {
        backgroundColor: 'transparent',
      },
    },
    '&.Mui-selected': {
      backgroundColor: alpha(
        theme.palette.primary.main,
        ODD_OPACITY + theme.palette.action.selectedOpacity,
      ),
      '&:hover, &.Mui-hovered': {
        backgroundColor: alpha(
          theme.palette.primary.main,
          ODD_OPACITY
            + theme.palette.action.selectedOpacity
            + theme.palette.action.hoverOpacity,
        ),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: alpha(
            theme.palette.primary.main,
            ODD_OPACITY + theme.palette.action.selectedOpacity,
          ),
        },
      },
    },
  },
}));

const SlaReturns = () => {
  const strt = new Date(new Date(new Date().getTime()).setDate(new Date().getDate() - 1));
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState(strt);
  const [endDate, setEndDate] = useState(strt);
  const [tableData, setTableData] = useState([]);
  const [otherTableData, setotherTableData] = useState([]);
  const [graphData, setGraphData] = useState([]);
  const [activePill, setActivePill] = useState('home');
  const [selectedYear, setSelectedYear] = useState(new Date());
  const [week, setWeek] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const { activeMenu } = useStateContext();
  const navigate = useNavigate();
  const isMounted = useRef(false);

  useEffect(() => {
    if (!isMounted.current) {
      isMounted.current = true;
      if (localStorage.getItem('loginID')) {
        setSelectedYear(new Date());
        getWeeks(new Date().getFullYear());
      }
    }
  }, []);
  useEffect(() => {
    if (!isMounted.current) {
      isMounted.current = true;
      if (localStorage.getItem('loginID')) {
        if (activePill === 'OtherData') {
          setStartDate(strt);
          setEndDate(strt);
          OtherDataTable(strt);
        }
      }
    }
  }, [activePill]);

  useEffect(() => {
    if (startDate === null || endDate === null) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Please Select Date!',
      });
      setStartDate(strt); // for compulsory dates
      setEndDate(strt); // for compulsory dates
    }
  }, [startDate, endDate]);
  const loginID = !localStorage.getItem('loginID') ? null : JSON.parse(localStorage.getItem('loginID'));

  const selectOptions = (week || []).slice().reverse().map((item) => ({
    value: item.FirstDayOfWeek,
    label: item.FirstDayOfWeek,
  }));
  const handleChange = (selected) => {
    if (selected.length <= 15) {
      setSelectedOptions(selected);
    }
  };
  const getWeeks = async (year) => {
    setLoading(true);
    const myHeaders = {
      'Content-Type': 'application/json',
    };
    const raw = JSON.stringify({
      UserId: loginID.UserId,
      ProcessName: variables.PROCESSNAME,
      PageName: 'Returns SLA',
      Year: year || new Date().getFullYear(),
    });

    const requestOptions = {
      method: 'post',
      url: `${variables.BASE_URL}ReturnsSLAWeek`,
      headers: myHeaders,
      data: raw,
    };

    try {
      const response = await axios(requestOptions);
      const { data } = response;
      if (data.IsSuccess) {
        setWeek(data.ReturnsSLA);
        // const result = data.ReturnsSLA?.map((item) => item.FirstDayOfWeek).join(',');
        const result = data.ReturnsSLA?.slice(0, 15).map((item) => item.FirstDayOfWeek).join(',');
        await graphDatApi(year, result);
        await InboundTable(year, result);
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: data.Reason,
        });
        setWeek([]);
        setGraphData([]);
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: error,
      });
      setWeek([]);
      setGraphData([]);
    }
    setLoading(false);
  };

  const InboundTable = async (year, weeksSelected) => {
    // const weeksSelected = selectedOptions.map((item) => item.value).join(',');
    // const year = new Date(selectedYear).getFullYear();
    setLoading(true);
    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');
    // Thu Jan 01 1970 05:30:00 GMT+0530
    const raw = JSON.stringify({
      UserId: loginID.UserId,
      ProcessName: variables.PROCESSNAME,
      PageName: 'Returns SLA',
      Week: weeksSelected || '',
      Year: year || new Date().getFullYear(),
    });

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow',
    };

    await fetch(`${variables.BASE_URL}ReturnsSLA`, requestOptions)
      .then((response) => response.text())
      .then((result) => {
        if (JSON.parse(result)?.IsSuccess !== false) {
          setTableData(JSON.parse(result)?.ReturnsSLA);
          // console.log(JSON.parse(result)?.ReturnsSLA);
        } else if (JSON.parse(result)?.IsSuccess !== true) {
          setTimeout(() => {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'No Data available for this Date!',
            });
          }, 0);
          setTableData([]);
        }
        setLoading(false);
      });
  };
  const handleEndDateChange = (date) => {
    setEndDate(date);
    if (startDate && startDate > date) {
      setStartDate(date);
    }
  };

  const handleStartDateChange = (date) => {
    setStartDate(date);
    if (endDate && endDate < date) {
      setEndDate(date);
      document.getElementById('datePicker_idend').focus();
    }
  };

  // const disableFutureDates = (date) => date.getTime() < new Date().getTime();
  const handlePillClick = (pill) => {
    isMounted.current = false;
    setActivePill(pill);
  };

  const graphDatApi = async (year, weeks) => {
    setLoading(true);
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };

    const data = {
      UserId: loginID.UserId,
      ProcessName: variables.PROCESSNAME,
      PageName: 'Returns SLA',
      Year: year || new Date().getFullYear(),
      Week: weeks,
    };

    await axios
      .post(`${variables.BASE_URL}ReturnsSLAGraph`, data, config)
      .then((response) => {
        if (response.data.IsSuccess) {
          setGraphData(response.data.ReturnsSLAGraph);
          // console.log(response.data.ReturnsSLAGraph);
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: response.data.Reason,
          });
          setGraphData([]);
        }
      })
      .catch((error) => {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: error,
        });
      });
    setLoading(false);
  };
  const renderYearContent = (year) => {
    const tooltipText = `Tooltip for year: ${year}`;
    return <span title={tooltipText}>{year}</span>;
  };

  const handleDateChange = (date) => {
    setSelectedYear(date);
    // console.log(date.getFullYear()); // Console the selected year
    const year = new Date(date).getFullYear();
    getWeeks(year);
    setSelectedOptions([]);
  };
  const disableFutureDates = (date) => date.getTime() < new Date().getTime();

  const OtherDataTable = async (defDate) => {
    setLoading(true);
    const isValidDate = defDate && (typeof defDate === 'string' || defDate instanceof Date);
    const finalFromDate = isValidDate ? defDate : startDate;
    const finalToDate = isValidDate ? defDate : endDate;

    try {
      const userData = JSON.parse(localStorage.getItem('loginID'));
      const userId = userData?.UserId ?? null;

      const payload = {
        UserId: userId,
        ProcessName: 'SimpliSafePortal',
        PageName: 'Returns SLA',
        FromDate: finalFromDate,
        ToDate: finalToDate,
      };

      const response = await axios.post(
        `${variables.BASE_URL}OtherSKU`,
        payload,
        { headers: { 'Content-Type': 'application/json' } },
      );

      const result = response.data;
      if (result?.IsSuccess !== false && result?.IsAuthorize !== false) {
        setotherTableData(result.OtherSKU);
      } else if (result?.IsSuccess !== true && result?.IsAuthorize) {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'No Data available for this Date!',
        });
        setotherTableData([]);
      } else if (result?.IsAuthorize !== true) {
      // UNAUTHORIZED
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Access Denied!',
        });
        navigate('/');
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error || 'Something went wrong. Please try again!',
      });
    } finally {
      setLoading(false);
    }
  };

  const BothDataCall = async () => {
    const weeksSelected = selectedOptions.map((item) => item.value).join(',');
    const year = new Date(selectedYear).getFullYear();
    await graphDatApi(year, weeksSelected);
    if (weeksSelected !== '') {
      InboundTable(year, weeksSelected);
    } else {
      setTableData([]);// to make empty if there no api call
    }
  };

  return (
    <div className="flex relative dark:bg-main-dark-bg">
      {activeMenu ? (
        <div className="w-72 fixed sidebar dark:bg-secondary-dark-bg bg-white ">
          <Sidebar />
        </div>
      ) : (
        <div className="w-0 dark:bg-secondary-dark-bg">
          <Sidebar />
        </div>
      )}
      <div style={{ width: `${activeMenu ? '100%' : '100%'} `, paddingLeft: `${activeMenu ? '300px' : '0px'}` }}>
        <div className="fixed md:static bg-main-bg dark:bg-main-dark-bg navbar w-full " id="navMenu_id">
          <Navbar />
          {activePill === 'OtherData' ? (
            <DateRangePicker
              loading={loading}
              startDate={startDate}
              endDate={endDate}
              handleStartDateChange={handleStartDateChange}
              handleEndDateChange={handleEndDateChange}
              disableFutureDates={disableFutureDates}
              TransferIntakeTable={() => OtherDataTable()}
              offSideMargin="60px"
            />
          ) : (
            <div className="container-fluid row" id="datePickercontainer_id" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <div className="row col-xs-12 col-sm-8 col-md-6 col-lg-6" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '10px', marginBottom: '-90px', marginTop: '-60px', marginLeft: '80px' }} id="SlaGraph_date_id">
                <div className="col-xs-8 col-sm-6 col-md-4 col-lg-4" style={{ width: '190px' }}>
                  <DatePicker
                    id="datePicker_id"
                    className="border border-gray-400 p-2 rounded-md text-gray-800 text-sm"
                    selected={selectedYear}
                    dateFormat="yyyy"
                    showYearPicker
                    onChange={handleDateChange}
                    maxDate={new Date()} // Disable future years
                    renderYearContent={renderYearContent}
                  />
                </div>
                <div className="col-xs-8 col-sm-6 col-md-4 col-lg-4" style={{ width: '420px' }}>
                  <Select
                    options={selectOptions}
                    isMulti
                    value={selectedOptions}
                    onChange={handleChange}
                    placeholder="Select First Day of Week"
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    components={{
                      Option: (props) => (
                        <components.Option {...props}>
                          <input
                            type="checkbox"
                            checked={props.isSelected}
                            onChange={() => null} // Prevent default checkbox behavior
                            style={{ marginRight: 10 }}
                          />
                          {props.label}
                        </components.Option>
                      ),
                    }}
                    styles={{
                      control: (base) => ({
                        ...base,
                        minHeight: '40px',
                        maxHeight: '40px',
                        overflow: 'hidden',
                      }),
                      valueContainer: (base) => ({
                        ...base,
                        overflow: 'hidden',
                        display: 'flex',
                        flexWrap: 'nowrap', // Prevents multi-line display
                      }),
                      multiValue: (base, state) => ({
                        ...base,
                        display: state.index > 2 ? 'none' : 'flex', // Show only first 3 selected values
                      }),
                      multiValueLabel: (base) => ({
                        ...base,
                        fontSize: '14px',
                      }),
                    }}
                  />
                </div>
                <Button onClick={BothDataCall} variant="contained" size="medium" className="col-xs-6 col-sm-4 col-md-2 col-lg-2">
                  Search
                </Button>
              </div>
            </div>
          )}

        </div>
        <div>
          <div className="container-fluid">
            <ul className="nav nav-pills" role="tablist" style={{ marginTop: '5px', marginBottom: '-10px' }}>
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link ${activePill === 'home' ? 'active' : ''}`}
                  id="home-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#home"
                  type="button"
                  role="tab"
                  aria-controls="home"
                  aria-selected={activePill === 'home'}
                  style={{
                    width: '150px',
                    fontSize: '20px',
                    backgroundColor: activePill === 'home' ? '#ffb013' : '',
                    color: activePill === 'home' ? 'black' : '',
                  }}
                  onClick={() => handlePillClick('home')}
                >
                  <strong>Graph</strong>
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link ${activePill === 'profile' ? 'active' : ''}`}
                  id="profile-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#profile"
                  type="button"
                  role="tab"
                  aria-controls="profile"
                  aria-selected={activePill === 'profile'}
                  style={{
                    width: '150px',
                    fontSize: '20px',
                    backgroundColor: activePill === 'profile' ? '#ffb013' : '',
                    color: activePill === 'profile' ? 'black' : '',
                  }}
                  onClick={() => handlePillClick('profile')}
                >
                  <strong>SLA Data</strong>
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link ${activePill === 'OtherData' ? 'active' : ''}`}
                  id="OtherData-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#OtherData"
                  type="button"
                  role="tab"
                  aria-controls="OtherData"
                  aria-selected={activePill === 'OtherData'}
                  style={{
                    width: '150px',
                    fontSize: '20px',
                    backgroundColor: activePill === 'OtherData' ? '#ffb013' : '',
                    color: activePill === 'OtherData' ? 'black' : '',
                  }}
                  onClick={() => handlePillClick('OtherData')}
                >
                  <strong>Other</strong>
                </button>
              </li>
            </ul>
            <div id="table_container">
              <div className=" tab-content" id="myTabContent">
                <div
                  className="tab-pane fade show active"
                  id="home"
                  role="tabpanel"
                  aria-labelledby="home-tab"
                >
                  <SLAGraph graphData={graphData} loading={loading} setLoading={setLoading} />
                </div>
                <div
                  className="tab-pane fade"
                  id="profile"
                  role="tabpanel"
                  aria-labelledby="profile-tab"
                >
                  <Paper className="table_backpaper2">
                    {loading ? (
                      <LoadingOverlay />
                    ) : (
                      <Box className="table_positions2">
                        <StripedDataGrid
                          sx={{ borderRadius: '20px' }}
                          columns={columns}
                          rows={tableData.map((row, index) => ({ ...row, id: index + 1 }))}
                          getRowId={(row) => row.id}
                          components={{ Toolbar: CustomToolbar }}
                          checkboxSelection
                          getRowClassName={(params) => (params.indexRelativeToCurrentPage % 2 === 0
                            ? 'even'
                            : 'odd')}
                          initialState={{
                            filter: {
                              filterModel: {
                                items: [],
                                quickFilterLogicOperator: GridLogicOperator.Or,
                              },
                            },
                          }}
                        />
                        <p className="dark:text-gray-500 text-gray-700 text-center " style={{ marginTop: '-30px' }}>
                          {variables.COPYRIGHT}
                        </p>
                      </Box>
                    )}
                  </Paper>
                </div>
                <div
                  className="tab-pane fade show"
                  id="OtherData"
                  role="tabpanel"
                  aria-labelledby="OtherData-tab"
                >
                  <Paper className="table_backpaper2">
                    {loading ? (
                      <LoadingOverlay />
                    ) : (
                      <Box className="table_positions2">
                        <CustomDataGrid
                          name="Other"
                          tableData={otherTableData}
                          column={columns2}
                        />
                      </Box>
                    )}
                  </Paper>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SlaReturns;
